<template>
	<el-dialog :title="pageTitle" :visible="showDialog" :show-close="false" top="10%">
        <el-form ref="orderForm" :model="orderForm" :rules="rules" class="has-disabledField">
            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-default">
                        <div class="box-body">
                            <el-row :gutter="10">
                                <el-col :span="12">
                                    <el-form-item label="订单类型" prop="order_type" :error="error.order_type" required>
                                        <el-select v-model="orderForm.order_type" @change="changeType" filterable placeholder="请选择" style="width:100%;">
                                          <el-option
                                            v-for="item in orderType"
                                            :key="item.order_type"
                                            :label="item.order_type_str"
                                            :value="item.order_type">
                                          </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="产品" prop="productId" :error="error.product_id">
                                        <el-cascader style="width:100%;" 
                                            :options="productSearchItem" :props="productSearchProps" v-model="orderForm.productId"
                                        ></el-cascader>
                                        <!-- <el-select v-model="orderForm.product_id" filterable placeholder="请选择" style="width:100%;" @change="changeProductItem">
                                          <el-option
                                          v-for="item in productSearchItem"
                                          :key="item.product_id"
                                          :label="item.product_name"
                                          :value="item.product_id">
                                        </el-option>
                                        </el-select> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="车牌号" prop="car_num" :error="error.car_num">
                                        <el-input v-model.trim="orderForm.car_num"><el-button v-if="orderForm.order_type!==1" slot="append" @click="syn">同步客户信息</el-button></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="购车价" prop="car_price" :error="error.car_price">
                                        <el-input v-model.trim="orderForm.car_price"><el-button v-if="orderForm.order_type!==1" slot="append" @click="syn">同步客户信息</el-button></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="车辆按揭状态" prop="pay_type" :error="error.pay_type">
                                        <el-select v-model="orderForm.pay_type" placeholder="请选择" style="width:100%;">
                                            <el-option
                                              v-for="o in payType"
                                              :key="o.value"
                                              :label="o.name"
                                              :value="o.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="按揭公司" prop="mortgage_company" :error="error.mortgage_company">
                                        <el-input v-model="orderForm.mortgage_company" :disabled="1 == orderForm.pay_type"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="申请金额" prop="apply_price" :error="error.apply_price">
                                        <el-input v-model="orderForm.apply_price">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="申请用途" prop="apply_purpose" :error="error.apply_purpose">
                                        <el-input v-model="orderForm.apply_purpose"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-default">
                        <div class="box-header">
                            <h3 class="box-title">客户信息</h3>
                        </div>
                        <div class="box-body">
                            <el-row :gutter="10">
                                <el-col :span="8">
                                    <el-form-item label="客户姓名" prop="name" :error="error.name">
                                        <el-input v-model="orderForm.name"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="手机号码" prop="phone" :error="error.phone">
                                        <el-input v-model="orderForm.phone"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="手机号码2" prop="phone2" :error="error.phone2">
                                        <el-input v-model="orderForm.phone2"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="身份证号" prop="idcard" :error="error.idcard">
                                        <el-input v-model="orderForm.idcard" @change="idCardChange"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="出生年月" prop="birthday" :error="error.birthday">
                                        <el-date-picker
                                          v-model="orderForm.birthday" type="date" placeholder="选择日期" style="width:100%;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="性别" prop="sex" :error="error.sex">
                                        <el-select v-model="orderForm.sex" placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in userSexItem"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="户口所在地" prop="resident_address" :error="error.resident_address">
                                        <el-input v-model="orderForm.resident_address">
                                            <el-cascader 
                                                :options="cities.list" :props="cities.props" v-model="orderForm.user_cityId"
                                                @active-item-change="(val) => {return citiesItemChange(val,true)}" slot="prepend"
                                            ></el-cascader>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-default">
                        <div class="box-header">
                            <h3 class="box-title">流程信息</h3>
                        </div>
                        <div class="box-body">
                            <el-row :gutter="10">
                                <el-col :span="20" v-if="showCheckCar">
                                    <span style="position: absolute;top: 10px; color: red;">*</span>
                                    <el-form-item label="是否验车" prop="is_check_car" style="margin-left: 10px;">
                                        <el-radio-group v-model="is_check_car">
                                            <el-radio :label="1">是</el-radio>
                                            <el-radio :label="0">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="估价方式" prop="car_load_type" :error="error.car_load_type">
                                        <el-select v-model="orderForm.car_load_type" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                                    v-for="item in carLoadType"
                                                    :key="item.value"
                                                    :label="item.name"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
		<div slot="footer" class="dialog-footer">
	        <el-button @click="showDialog = false">取 消</el-button>
	        <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
	    </div>
	</el-dialog>
</template>
<style>
    .el-input-group__prepend .el-cascader { display: block; margin:-10px; width:200px; border-radius: 0; }
</style>
<script type="text/ecmascript-6">
import $ from 'jquery'
import async from 'async'
import _ from 'lodash'
import _this from '../../lib/common/createWin'


let _p = window.xwCommon,
    pageTitle = _this.title,
    name = _this.name,
    methods = {
        citiesItemChange(val,isUser){
            switch(val.length){
              case 2:
                //this.cities.value["city_id"] = val[1]
                _this.getDistrictList(this,val)
                //console.log("lll")
                return;
              case 1:
                _this.getCityList(this, val[0], 2)
                //console.log("kkk")
                return;
              default:
                this.$alert("无效的选项信息",pageTitle);
                return;
            }
        
        },
        idCardChange(val){
            this.$set(this.orderForm,"idcard",val.toLocaleUpperCase())
            let info = _p.getIDCardInfo(val)
            //console.log(info)
            if(info){
                this.$set(this.orderForm,"sex",info.sex)
                this.$set(this.orderForm,"birthday",info.birthday)
            }
            
        },
        syn(){
            if(this.orderForm.car_num!==undefined&&this.orderForm.car_num!=="") {
                _this.getCustomer(this,this.orderForm.car_num)
            }
            else this.$alert("请输入车牌号后同步信息",this.pageTitle)
        },
        changeProductItem(val){
            //_this.changeProductSearch(this)
            let item = _.find(this.productSearchItem,(o) => {return o.product_id == val})
            if(item.business_type_id == 1){
                this.loanTypeOnly = true
                this.$set(this.orderForm,"car_load_type",1)
            }else{
                this.loanTypeOnly = false
            }
        },
    	submit(){
            async.waterfall([
                (next) => {
                    this.$refs["orderForm"].validate((valid) => {
                        if (valid) next(null)
                        else next(new Error("请修改表单错误后再提交！"))
                    });
                },
                (next) => {
                    this.submitLoading = true;
                    this.orderForm.is_check_car = this.is_check_car;
                    _this.submit(this).then((data) => next(null,data),(err) => next(err))
                },
                (data,next) => {
                    this.showDialog = false
                    this.$bus.emit('reloadTodo')
                    next(null)
                }
            ],(err) =>{
                this.submitLoading = false
                if(err){
                    console.log(err)
                    this.$alert(err.message,_this.title)
                }
            })
    		
    		//this.$emit('callback',this.currDept)
    	},
        changeType(){
            let _ = this;
            let order_type = _.orderForm.order_type;
            if(order_type == 5){
                _.showCheckCar = true;
            }else{
                _.showCheckCar = false;
            }
        },
    }
export default {
    name, methods, 
    props:{"visible":{type:Boolean, default:false }},
    data: () => { return {
    	pageTitle, treeLoading:false, showDialog:false, currDept:undefined, loanTypeOnly: false, submitLoading:false, 
        cities: { list:[], props:_p.getStoredProp("_/cities/props") },
        productSearchProps:{ "label":"product_name", "value":"product_id", "children":"childrens" },
        userSexItem:_p.getStoredProp("_/default/sex"),
        carLoadType:_p.getStoredProp("_/default/create/carLoadType"),
        payType:_p.getStoredProp("_/default/car/payType"),
        orderForm:{},rules:_this.rules, error:{}, productSearchItem:[], orderType:[],is_check_car:1,showCheckCar:false
    } },
    watch:{
        visible:function(val){
            if(val){
                _this.initWin(this)
            }else
                this.showDialog = false
        },
        showDialog:function(val){
            if(!val) this.$emit('closed')
        }
    },
    mounted(){
        //_this.initArea(this).then()
    }
}
</script>


// WEBPACK FOOTER //
// createWin.vue?63135e11